/* ============================================================
   BE YOU — il testo inciso accetta solo caratteri latini.
   Pana Mio, 19/09/2026.

   Perche' serve: la personalizzazione la gestisce l'app Product
   Personalizer, che NON filtra i caratteri (verificato nel suo
   pplr_common.js: nessun controllo). Da quando il negozio e'
   pubblicato in ebraico, giapponese, coreano, greco e bulgaro, un
   cliente puo' scrivere nel proprio alfabeto: i 42 font selezionati
   sono latini, quindi in anteprima e in produzione uscirebbero
   quadratini o spazi vuoti. Meglio impedirlo mentre scrive.

   Filtra SOLO i campi del personalizzatore. Non tocca ricerca,
   newsletter, contatti, indirizzi.
   ============================================================ */
(function () {
  'use strict';

  // lettere latine (anche accentate), cifre, spazio e punteggiatura comune
  var VIETATI = /[^A-Za-z0-9À-ɏ \-_.,'&!?@#()\/+:]/g;

  var MSG = {
    it:"Solo caratteri latini", en:"Latin characters only", fr:"Caractères latins uniquement",
    de:"Nur lateinische Zeichen", es:"Solo caracteres latinos", "pt-PT":"Apenas caracteres latinos",
    nl:"Alleen Latijnse tekens", pl:"Tylko znaki łacińskie", sv:"Endast latinska tecken",
    da:"Kun latinske tegn", fi:"Vain latinalaisia merkkejä", nb:"Bare latinske tegn",
    cs:"Pouze latinka", ro:"Doar caractere latine", el:"Μόνο λατινικοί χαρακτήρες",
    hr:"Samo latinični znakovi", bg:"Само латински букви", he:"אותיות לטיניות בלבד",
    ja:"ラテン文字のみ", ko:"라틴 문자만 입력 가능"
  };
  function messaggio() {
    var l = (document.documentElement.getAttribute('lang') || 'en');
    return MSG[l] || MSG[l.split('-')[0]] || MSG.en;
  }

  var RX_CONTENITORE = /pplr|personaliz|product-?designer|customify/i;
  var ESCLUDI = /search|newsletter|contact|email|password|address|phone|zip|discount|quantity/i;

  function eNostro(el) {
    if (!el || !el.tagName) return false;
    var t = el.tagName.toLowerCase();
    if (t !== 'input' && t !== 'textarea') return false;
    if (t === 'input') {
      var type = (el.getAttribute('type') || 'text').toLowerCase();
      if (['text', 'search', ''].indexOf(type) === -1) return false;
    }
    var proprio = (el.name || '') + ' ' + (el.id || '') + ' ' + (el.className || '');
    if (ESCLUDI.test(proprio)) return false;
    if (RX_CONTENITORE.test(proprio)) return true;
    // oppure: sta dentro il widget del personalizzatore
    for (var n = el.parentElement, i = 0; n && i < 12; n = n.parentElement, i++) {
      var s = (n.id || '') + ' ' + (typeof n.className === 'string' ? n.className : '');
      if (RX_CONTENITORE.test(s)) return true;
    }
    return false;
  }

  function avvisa(el) {
    var id = 'avviso-solo-latino';
    var box = el.parentElement && el.parentElement.querySelector('.' + id);
    if (!box) {
      box = document.createElement('div');
      box.className = id;
      box.setAttribute('role', 'status');
      box.style.cssText = 'font-size:12px;line-height:1.4;margin-top:4px;opacity:.85';
      if (el.parentElement) el.parentElement.appendChild(box);
    }
    box.textContent = messaggio();
    clearTimeout(box._t);
    box._t = setTimeout(function () { box.textContent = ''; }, 2500);
  }

  function pulisci(e) {
    var el = e.target;
    if (!eNostro(el)) return;
    var v = el.value;
    if (!v || !VIETATI.test(v)) return;
    var pos = el.selectionStart, prima = v.length;
    var nuovo = v.replace(VIETATI, '');
    el.value = nuovo;
    try { var d = prima - nuovo.length; el.setSelectionRange(Math.max(0, pos - d), Math.max(0, pos - d)); } catch (err) {}
    avvisa(el);
  }

  // 'input' copre digitazione, incolla, trascinamento e tastiere mobili
  document.addEventListener('input', pulisci, true);
  document.addEventListener('change', pulisci, true);
})();
